<div class="page-container">
  <div class="page-content">
    <form [formGroup]="form" (submit)="handleSaveNewPassword($event)" class="alterar-senha-form">
      <mat-form-field *ngIf="isInternal" class="form-field"  [class.error-margin]="hasAnyError('currentPassword')"  appearance="outline">
        <mat-label>Senha atual</mat-label>
        <input
          matInput 
          name="inputSenha"
          formControlName="currentPassword"
          placeholder="Senha atual"
          autocomplete="off"
          minlength="8"
          autofocus
          tabindex="1"
          [type]="showCurrentPassword ? 'text' : 'password'">
        <button mat-icon-button matSuffix type="button" (click)="showCurrentPassword = !showCurrentPassword" [attr.aria-label]="'Esconder senha'" [attr.aria-pressed]="showCurrentPassword">
          <mat-icon class="suffix-icon" matSuffix>{{showCurrentPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <mat-error *ngIf="form.get('currentPassword').touched && form.get('currentPassword').hasError('required')">
          <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
          Este campo é obrigatório!
        </mat-error>
        <mat-error *ngIf="form.get('currentPassword').touched && form.get('currentPassword').hasError('minlength')">
          <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
          Este campo deve possuir no mínimo 8 caracteres!
        </mat-error>
        <mat-error *ngIf="form.get('currentPassword').touched && form.get('currentPassword').hasError('wrongPassword')">
          <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
          Senha inválida
        </mat-error>
      </mat-form-field>

      <mat-form-field  class="form-field new-password" [ngClass]="{'new-password': showValidation}" appearance="outline">
        <mat-label>{{ isInternal ? 'Nova senha' : 'Senha' }}</mat-label>
        <input 
          matInput 
          name="inputConfirmarSenha"
          formControlName="newPassword"
          type="password"
          [placeholder]="isInternal ? 'Nova senha' : 'Senha'" 
          autocomplete="off"
          minlength="8"
          maxlength="18"
          tabindex="2"
          (focus)="showValidation = true"
          [type]="showNewPassword ? 'text' : 'password'">
          <button mat-icon-button matSuffix type="button" (click)="showNewPassword = !showNewPassword" [attr.aria-label]="'Esconder senha'" [attr.aria-pressed]="showNewPassword">
            <mat-icon class="suffix-icon" matSuffix>{{showNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
       </mat-form-field>
        <div *ngIf="showValidation" class="errors-container">
          <span>
            <mat-icon class="material-symbols-outlined flat" [ngClass]="getIconByErrorStatus('minlength').color">
              {{getIconByErrorStatus('minlength').icon}}
            </mat-icon> Mínimo 8 dígitos
          </span>
          <span>
            <mat-icon class="material-symbols-outlined flat" [ngClass]="getIconByErrorStatus('hasNumber').color">
              {{getIconByErrorStatus('hasNumber').icon}}
            </mat-icon> Pelo menos 1 número (0-9)
          </span>
          <span>
            <mat-icon class="material-symbols-outlined flat" [ngClass]="getIconByErrorStatus('hasSpecialCharacters').color">
              {{getIconByErrorStatus('hasSpecialCharacters').icon}}
            </mat-icon> Pelo menos 1 caractere especial (@, #, !)
          </span>
          <span>
            <mat-icon class="material-symbols-outlined flat" [ngClass]="getIconByErrorStatus('hasCapitalCase').color">
              {{getIconByErrorStatus('hasCapitalCase').icon}}
            </mat-icon> Pelo menos uma letra maiúscula (A-Z)
          </span>
          <span>
            <mat-icon class="material-symbols-outlined flat" [ngClass]="getIconByErrorStatus('hasSmallCase').color">
              {{getIconByErrorStatus('hasSmallCase').icon}}
            </mat-icon> Pelo menos uma letra minúscula (a-z)
          </span>
        </div>
      
      <mat-form-field class="form-field" [class.error-margin]="hasAnyError('confirmPassword') || passwordsNotMatch" appearance="outline">
        <mat-label>{{ isInternal ? 'Confirme a nova senha' : 'Confirme a senha' }}</mat-label>
        <input 
          matInput 
          name="inputConfirmarSenha"
          formControlName="confirmPassword"
          [errorStateMatcher]="matcher"
          type="password"
          [placeholder]="isInternal ? 'Confirme a nova senha' : 'Confirme a senha'" 
          autocomplete="off"
          minlength="8"
          maxlength="18"
          tabindex="3"
          enterkeyhint="send"
          [type]="showConfirmPassword ? 'text' : 'password'">
          <button mat-icon-button matSuffix type="button" (click)="showConfirmPassword = !showConfirmPassword" [attr.aria-label]="'Esconder senha'" [attr.aria-pressed]="showConfirmPassword">
            <mat-icon class="suffix-icon" matSuffix>{{showConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        <mat-error *ngIf="form.get('confirmPassword').touched && form.get('confirmPassword').hasError('required') && !form.hasError('passwordsDoNotMatch')">
          <mat-icon color="warn" class="material-symbols-outlined mat-icon-error">error</mat-icon>
          Este campo é obrigatório!
        </mat-error>
        <mat-error *ngIf="form.get('currentPassword').touched && form.get('currentPassword').hasError('minlength') && !form.hasError('passwordsDoNotMatch')">
          <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
          Este campo deve possuir no mínimo 8 caracteres!
        </mat-error>
        <mat-error class="error" *ngIf="form.hasError('passwordsDoNotMatch')">
          <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
          Deve ser igual à nova senha 
        </mat-error>
      </mat-form-field>

      <div class="actions">
        <button mat-stroked-button type="button" tabindex="4" (click)="handleCancel()" class="outlined" color="primary" >
          Cancelar
        </button>
        <button [disabled]="form.invalid" tabindex="5" mat-flat-button color="primary">
          <mat-icon class="spinner" *ngIf="loading">
            <mat-spinner diameter="20">
            </mat-spinner>
          </mat-icon>
          <span *ngIf="!loading">Salvar</span>  
        </button>
      </div>
    </form>
  </div>
</div>